/* The selector row: one summary pill, a VIN chip, and a rule about space.

   THE RULE, FIRST. Nothing in this row is ever truncated. "Sport Ran..." and
   "Super Sp..." are not shorter labels, they are broken ones: the customer
   cannot read them and cannot tell whether the value is right. When the row
   runs out of room it drops a whole value instead, one at a time, Range first
   and then Year. Model and the VIN never go, because those two are the trailer.

   THE MIDDLE THREE ARE ONE CONTAINER. Range, Model and Year each had a caption
   over a value, which is three captions restating what the values already say.
   The captions go and the three values share one pill, the way the home page's
   Find your trailer bar does. They stay three separate buttons inside it, each
   with its own menu, so clicking behaves exactly as it did.

   ON A DESKTOP dropping a value means hiding a chip, and that is still done
   here. ON A PHONE the row is a single summary button, and this file no longer
   touches its text. RETIRED 30 SEP 2026, AND WHY: this file used to shorten
   .vin-fx-mobile-filter-label and .vin-fx-fsheet-trigger__label by taking
   segments off the string, keeping the full string on data-fx-full. It only
   replaced that cache when a new string had MORE segments than the old one.
   So after a switch from "Sport Range - Pro Sport - 2025" to "SHIFTR 1883 -
   2026", or from Pro Sport to Super Sport, it wrote the previous trailer back
   over the extension's correct label about 70ms after every render, and the
   label stayed wrong for the rest of the visit. That was bug 8b. It was the
   third copy of the label shortener: fx-ios.js and fx-ios-e.js had already
   been retired for fighting the extension over the same node. The extension
   now drops whole values itself (fitSummaryLabel in vin-search-modal.js), so
   it is the only writer. Do not bring text writes back into this file.

   THE VIN CHIP runs the extension's own search. There is a .vin-search-panel
   inside the modal carrying #vinInput and .vin-search-btn; the modal hides it
   once results are showing, but it is still there and still wired. Writing the
   VIN into it and clicking its button is exactly what a customer does by hand,
   so there is no second code path to keep in step. The value goes in through
   the native setter, because assigning input.value directly updates the DOM and
   tells a framework nothing, and the search then runs against the old value.

   ONE CHIP, NOT TWO. The first cut appended the chip to whatever host existed
   when the pass ran, and on the first pass .vin-fx-selector does not exist yet,
   so it landed on the row and a later pass added a second inside the selector.
   Two VIN chips, both truncated, and the card measured to the stray. Now any
   duplicate is removed and the survivor is moved into place.

   THE CARD'S WIDTH IS A NUMBER SET FROM HERE, and it should be one line of CSS.
   It is not. width: max-content, width: fit-content and justify-self: start all
   collapse the row to the marque plus its padding, because .vin-fx-context-bar
   contributes nothing under intrinsic sizing. The last chip's right edge plus
   the card's right padding is the same answer and the browser gives it freely.

   THE ROOM IS MEASURED AGAINST THE SHEET, NOT THE CARD'S OWN COLUMN. The card
   sits in a grid column that sizes itself to the card, so asking the column how
   much room there is asks the card about itself. The honest bound is the
   modal's own content box. And it is re-measured when the sheet settles: the
   modal animates open, so a pass on the way in measures a third of the final
   width and drops values that would have fitted. A ResizeObserver on the
   content box catches the end of that animation and cannot feed itself, since
   nothing here changes the width of the box it watches.

   NOTHING MAY CENTRE THE CONTENTS OF THIS ROW. contentWidth() measures from
   the row's own left edge to the right edge of the last chip, so centring the
   chips inside it puts the empty gap on the left into the measurement, and
   every pass then writes back a number the next pass disagrees with. It
   strobes. If the row needs to sit in the middle of its column, centre the
   ROW, with auto side margins, once this file has already sized it to its
   content. fx-scale.css does exactly that and says so.

   WHY THERE IS A writing FLAG. Hiding a chip and setting the card's width are
   DOM writes and the MutationObserver watches the body, so a pass could feed
   itself every 60ms forever. Mutation records arrive as a microtask, before
   the timeout that clears the flag.

   WHY THE WIDTH IS ANIMATED, AND WHY THE MEASUREMENT IS NOT. Switching marque
   changes the wordmark's width and every chip's label at once, and the assets
   land at slightly different moments, so the row is re-fitted several times
   over a few hundred milliseconds. Each fit was a hard jump, which is what
   made the switch feel clunky. A transition on max-width smooths that, but it
   cannot be on while fitCard is measuring: the pass clears max-width and reads
   the layout back synchronously, and a transitioning value reads as whatever
   it is part way through rather than as the truth. So the measurement is taken
   with the transition off, the painted value is put back, the style is flushed,
   and only then is the transition re-enabled and the target set. The browser
   paints once, at the end, and glides from the old width to the new one.

   setTimeout, not requestAnimationFrame: rAF does not fire in a tab that is not
   being painted, and a queued flag that is never cleared drops every mutation
   after it. */
(function () {
  var queued = null;
  var writing = false;
  var watched = null;

  var PILL = ['range', 'model', 'year'];
  var DROP = ['range', 'year'];
  var CAPTION = 'diagrams-match-caption--chips';
  var EASE = 'cubic-bezier(.25, .1, .25, 1)';
  var TR = 'max-width .26s ' + EASE;

  var CHEV =
    '<svg viewBox="0 0 12 8" fill="none" aria-hidden="true">' +
    '<path d="M1 1.5 6 6.5 11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function onBrandPick(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var opt = t.closest('.vin-fx-selchip-option');
    if (!opt) return;
    var wrap = opt.closest('.vin-fx-brand-switch-wrap');
    if (!wrap) return;
    var sw = wrap.querySelector('.vin-fx-brand-switch');
    if (!sw) return;
    var next = /shiftr/i.test(opt.textContent) ? 'shiftr' : 'futura';
    if (sw.getAttribute('data-fx-brand') !== next) sw.setAttribute('data-fx-brand', next);
  }

  function currentVin() {
    try {
      var raw = window.localStorage.getItem('lastSearchedTrailer');
      var o = raw ? JSON.parse(raw) : null;
      if (o && o.vinNumber) return String(o.vinNumber).trim();
    } catch (e) { /* private mode, or a value that is not JSON */ }
    return '';
  }

  function runSearch(vin) {
    var input = document.getElementById('vinInput');
    var btn = document.querySelector('.vin-modal .vin-search-btn');
    var set = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;

    if (input && btn) {
      set.call(input, vin);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      btn.click();
      return;
    }
    var hero = document.getElementById('vinHeroInput');
    var form = hero && hero.closest('form');
    if (!hero || !form) return;
    set.call(hero, vin);
    hero.dispatchEvent(new Event('input', { bubbles: true }));
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  /* The caption paragraph is in this list for the drop rule only: on a desktop
     it holds the selector card, whose chips can still be dropped. It must never
     be given a width of its own. */
  function cards() {
    return document.querySelectorAll(
      '.vin-modal .vin-fx-context-row,' +
      '.vin-modal .vin-fx-parts-controls .vin-fx-selector,' +
      '.vin-modal .vin-fx-parts-controls .' + CAPTION
    );
  }

  function isCaption(card) { return card.classList.contains(CAPTION); }

  function hostIn(card) {
    return card.querySelector('.vin-fx-selector') ||
      (card.classList.contains('vin-fx-selector') ? card : null);
  }

  function build() {
    var wrap = document.createElement('span');
    wrap.className = 'vin-fx-selchipwrap fx-vinchip';
    wrap.innerHTML =
      '<button type="button" class="vin-fx-selchip fx-vinchip__btn"' +
      ' aria-haspopup="dialog" aria-expanded="false">' +
        '<span class="vin-fx-selchip-cap">VIN</span>' +
        '<span class="vin-fx-selchip-val"></span>' +
        '<span class="vin-fx-selchip-chev" aria-hidden="true">' + CHEV + '</span>' +
      '</button>' +
      '<div class="fx-vinpop" hidden>' +
        '<span class="fx-vinpop__lab">Change trailer</span>' +
        '<div class="fx-vinpop__row">' +
          '<input class="fx-vinpop__in" type="text" inputmode="numeric" autocomplete="off"' +
          ' maxlength="5" placeholder="04178" aria-label="Last five digits of your VIN">' +
          '<button type="button" class="fx-vinpop__go">Find</button>' +
        '</div>' +
        '<p class="fx-vinpop__note">The last 5 digits of your VIN.</p>' +
      '</div>';
    return wrap;
  }

  function syncChip(card, vin) {
    var host = hostIn(card);
    if (!host) return;

    var found = card.querySelectorAll('.fx-vinchip');
    var wrap = found[0] || null;
    for (var i = 1; i < found.length; i++) found[i].remove();

    if (!vin) { if (wrap) wrap.remove(); return; }
    if (!wrap) wrap = build();
    if (wrap.parentNode !== host || wrap !== host.lastElementChild) host.appendChild(wrap);

    var val = wrap.querySelector('.vin-fx-selchip-val');
    if (val.textContent !== vin) val.textContent = vin;
  }

  /* The wordmark is a different width per marque, so it jumps on the switch
     unless it is told to move. Set once, inline, because it belongs with the
     rest of the movement this file owns rather than in a stylesheet three
     files away. */
  function easeLogo(card) {
    var logo = card.querySelector('.vin-fx-bar-logo');
    if (!logo || logo.getAttribute('data-fx-tr')) return;
    logo.setAttribute('data-fx-tr', '1');
    if (!reducedMotion()) logo.style.transition = 'width .26s ' + EASE;
  }

  function ensurePill(card) {
    var host = hostIn(card);
    if (!host) return;

    var wraps = [];
    for (var i = 0; i < PILL.length; i++) {
      var w = host.querySelector('[data-chip-wrap="' + PILL[i] + '"]');
      if (w) wraps.push(w);
    }
    if (wraps.length < 2) return;

    var pill = host.querySelector('.fx-sumpill');
    if (!pill) {
      pill = document.createElement('span');
      pill.className = 'fx-sumpill';
      host.insertBefore(pill, wraps[0]);
    }
    for (var j = 0; j < wraps.length; j++) {
      if (wraps[j].parentNode !== pill) pill.appendChild(wraps[j]);
    }
  }

  /* ---- dropping a value: desktop chips only ---- */
  function showAll(card) {
    var off = card.querySelectorAll('.fx-chip-off');
    for (var i = 0; i < off.length; i++) off[i].classList.remove('fx-chip-off');
  }

  function dropOne(card, key) {
    var w = card.querySelector('[data-chip-wrap="' + key + '"]');
    if (w && !w.classList.contains('fx-chip-off') && w.getBoundingClientRect().width) {
      w.classList.add('fx-chip-off');
    }
  }

  function roomFor(card) {
    var box = card.closest('.vin-modal-content') || card.parentElement;
    if (!box) return card.clientWidth;

    var bs = window.getComputedStyle(box);
    var padL = parseFloat(bs.paddingLeft) || 0;
    var padR = parseFloat(bs.paddingRight) || 0;
    var br = box.getBoundingClientRect();
    var inner = br.width - padL - padR;
    var offset = card.getBoundingClientRect().left - (br.left + padL);
    return Math.floor(inner - (offset > 0 ? offset : 0));
  }

  function contentWidth(card) {
    var pad = parseFloat(window.getComputedStyle(card).paddingRight) || 0;
    var left = card.getBoundingClientRect().left;
    var right = left;
    var parts = card.querySelectorAll(
      '.vin-fx-selchipwrap, .fx-sumpill, .vin-fx-mobile-filter-toggle, .vin-fx-fsheet-trigger'
    );
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].classList.contains('fx-chip-off')) continue;
      var r = parts[i].getBoundingClientRect();
      if (!r.width) continue;
      if (r.right > right) right = r.right;
    }
    return Math.ceil(right - left + pad);
  }

  function fitCard(card) {
    if (card.querySelector('.fx-vinpop:not([hidden])')) return;

    var animate = !isCaption(card) && !reducedMotion();
    var painted = card.style.maxWidth;

    /* Measure with nothing in motion. All of this is one synchronous task, so
       none of the intermediate states is ever painted. */
    if (animate) card.style.transition = 'none';
    if (!isCaption(card)) card.style.maxWidth = '';
    showAll(card);

    var room = roomFor(card);
    var want = contentWidth(card);

    for (var d = 0; d < DROP.length && want > room; d++) {
      dropOne(card, DROP[d]);
      want = contentWidth(card);
    }

    if (isCaption(card)) return;

    var next = (want > 0 && want < room) ? want + 'px' : '';

    if (!animate) { card.style.maxWidth = next; return; }

    /* Put the painted width back while still untransitioned and flush it, so
       the transition that follows has an old value to move away from. Without
       the flush the browser coalesces both writes and nothing animates. */
    card.style.maxWidth = painted;
    void card.offsetWidth;
    card.style.transition = TR;
    card.style.maxWidth = next;
  }

  function watchSheet() {
    if (watched || !window.ResizeObserver) return;
    var box = document.querySelector('.vin-modal-content');
    if (!box) return;
    watched = new window.ResizeObserver(function () { schedule(); });
    watched.observe(box);
  }

  function sync() {
    watchSheet();
    var vin = currentVin();
    var list = cards();
    for (var i = 0; i < list.length; i++) {
      if (!isCaption(list[i])) {
        easeLogo(list[i]);
        ensurePill(list[i]);
        syncChip(list[i], vin);
      }
      fitCard(list[i]);
    }
  }

  function closeAll(except) {
    var all = document.querySelectorAll('.fx-vinchip');
    for (var i = 0; i < all.length; i++) {
      if (all[i] === except) continue;
      var pop = all[i].querySelector('.fx-vinpop');
      var btn = all[i].querySelector('.fx-vinchip__btn');
      if (pop) pop.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }

  function submit(wrap) {
    if (!wrap) return;
    var input = wrap.querySelector('.fx-vinpop__in');
    var vin = String(input.value || '').trim();
    if (!vin) { input.focus(); return; }
    closeAll(null);
    runSearch(vin);
  }

  /* Capture phase, because the extension closes its own menus on any click
     inside the row and would shut this panel on the way in. */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    var go = t.closest('.fx-vinpop__go');
    if (go) {
      ev.preventDefault();
      ev.stopPropagation();
      submit(go.closest('.fx-vinchip'));
      return;
    }

    if (t.closest('.fx-vinpop')) { ev.stopPropagation(); return; }

    var btn = t.closest('.fx-vinchip__btn');
    if (btn) {
      ev.preventDefault();
      ev.stopPropagation();
      var wrap = btn.closest('.fx-vinchip');
      var pop = wrap.querySelector('.fx-vinpop');
      var opening = pop.hidden;
      closeAll(wrap);
      pop.hidden = !opening;
      btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      if (opening) {
        var field = pop.querySelector('.fx-vinpop__in');
        field.value = wrap.querySelector('.vin-fx-selchip-val').textContent.trim();
        field.focus();
        field.select();
      }
      return;
    }

    closeAll(null);
  }, true);

  document.addEventListener('click', onBrandPick);

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape') { closeAll(null); return; }
    var t = ev.target;
    if (ev.key !== 'Enter' || !t || !t.classList) return;
    if (!t.classList.contains('fx-vinpop__in')) return;
    ev.preventDefault();
    submit(t.closest('.fx-vinchip'));
  });

  function pass() {
    queued = null;
    writing = true;
    try { sync(); } catch (e) { /* the row is not built yet */ }
    window.setTimeout(function () { writing = false; }, 0);
  }

  function schedule() {
    if (writing || queued) return;
    queued = window.setTimeout(pass, 60);
  }

  function boot() {
    pass();
    window.addEventListener('resize', function () {
      writing = false;
      schedule();
    });
    if (!window.MutationObserver) return;
    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
